import {
  genAIChat,
  genAIEmailTemplates,
  genAIGenerate,
  genAIsession,
} from "../constant/Constant";
import {
  deleteAuthMethod,
  getAuthMethod,
  patchAuthMethod,
  postAuthMethod,
} from "../services/HttpServices";
import {
  GENAI_CREATE_SESSION_SUCCESS,
  GENAI_STREAM_APPEND,
  GENAI_CLEAR_MESSAGES,
  GENAI_LOADING,
  EMAIL_TEMPLATES,
  GENAI_CHAT_CONVERSATION,
} from "../actionType/genAIType";
import { getUserInfo } from "../utils/utils";

export const appendStreamMessage = (msg) => ({
  type: GENAI_STREAM_APPEND,
  payload: msg,
});

export const clearMessages = () => ({
  type: GENAI_CLEAR_MESSAGES,
});

export const getEmailTemplates = () => async (dispatch) => {
  try {
    dispatch({ type: GENAI_LOADING, payload: true });
    const response = await getAuthMethod(genAIEmailTemplates);

    dispatch({
      type: EMAIL_TEMPLATES,
      payload: response?.data || [],
    });
  } catch (error) {
    console.error("Template fetch failed:", error);
  } finally {
    dispatch({ type: GENAI_LOADING, payload: false });
  }
};

export const createAISession = () => async (dispatch) => {
  try {
    dispatch({ type: GENAI_LOADING, payload: true });

    const { id } = getUserInfo();

    const response = await postAuthMethod(genAIsession, {
      userId: id,
      query: "init",
    });

    dispatch({
      type: GENAI_CREATE_SESSION_SUCCESS,
      payload: response,
    });

    return response;
  } catch (error) {
    console.error("AI Session Create Failed:", error);
    throw error;
  } finally {
    dispatch({ type: GENAI_LOADING, payload: false });
  }
};

export const generateEmailAI = (payload) => async (dispatch) => {
  try {
    dispatch({ type: GENAI_LOADING, payload: true });

    const response = await postAuthMethod(genAIGenerate, payload);

    return response?.data || response;
  } catch (error) {
    console.error("AI Generate Email API Failed:", error);
    throw error;
  } finally {
    dispatch({ type: GENAI_LOADING, payload: false });
  }
};

export const appendChatMessage = (msg) => ({
  type: GENAI_CHAT_CONVERSATION,
  payload: {
    ...msg,
    id: Date.now(),
    from: "bot",
    text: msg?.message,
    stage: msg?.stage,
  },
});

export const resetChatConversation = () => (dispatch) => {
  dispatch({
    type: GENAI_CHAT_CONVERSATION,
    payload: null,
  });
};

export const setLoading = (payload) => ({
  type: GENAI_LOADING,
  payload: payload,
});

export const aiChatConversation = (payload) => async (dispatch) => {
  try {
    dispatch({ type: GENAI_LOADING, payload: true });

    const response = await patchAuthMethod(genAIChat, null, payload);

    return response?.data || response;
  } catch (error) {
    console.error("Chat generation failed:", error);
    throw error;
  } finally {
    dispatch({ type: GENAI_LOADING, payload: false });
  }
};

export const userConversationMessage = (payload) => async (dispatch) => {
  dispatch({
    type: GENAI_CHAT_CONVERSATION,
    payload: { id: Date.now(), from: "user", text: payload },
  });
};

export const resetChatSession = (sessionId) => (dispatch) => {
  dispatch({
    type: GENAI_LOADING,
    payload: true,
  });
  return deleteAuthMethod(`${genAIsession}/${sessionId}`)
    .then((res) => {
      dispatch({
        type: GENAI_LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: GENAI_LOADING,
        payload: false,
      });
      return err;
    });
};
